import type { Language } from "../language"

export type DatabankDifficulty = "easy" | "hard"

export interface ReadingText {
  id: string
  name: string
  image: string
  copyright?: string
  difficulty: DatabankDifficulty
}

export interface ReadingTextContent {
  // Matches the reading text id
  id: string
  language: string
  title: string
  subtitle?: string
  contentParagraphs: string[]
  questions: string[]
  supplementary?: string[]
  tags?: string[]
  source?: string[] | string
}

export interface ReadingTextCategory {
  entries: ReadingText[]
  translations: {
    [id: string]: {
      [language in Language]?: ReadingTextContent
    }
  }
}

export type WordlistCategory = {
  [language in Language]: {
    [difficulty in DatabankDifficulty]: string[][]
  }
}

export const allDatabankThemes = [
  "birds",
  "bugs",
  "christmas",
  "colours",
  "clothes",
  "farmAnimals",
  "forestAnimals",
  "fruitsAndBerries",
  "months",
  "myFamily",
  "myHouse",
  "space",
  "theBodyExternal",
  "theBodyInternal",
  "vegetables",
  "waterSeashore",
  "weatherAndSeasons",
  "weekdays",
] as const
export type DatabankTheme = (typeof allDatabankThemes)[number]
export type DataBank = {
  readingTexts: {
    [theme in DatabankTheme]: ReadingTextCategory
  }
  wordlists: {
    [theme in DatabankTheme]: WordlistCategory
  }
}
